import { createContext, useContext, useMemo, useState } from 'react';

export const themes = {
  matrix: {
    label: 'Matrix',
    vars: {
      '--bg':        '#020602',
      '--bg-soft':   '#071207',
      '--panel':     '#0a170a',
      '--line':      '#2cff75',
      '--line-soft': '#1a7e43',
      '--text':      '#e8ffee',
      '--muted':     '#a8ddb5',
      '--accent':    '#2cff75',
      '--accent-2':  '#9effbc',
    },
  },
  cyan: {
    label: 'Cyan',
    vars: {
      '--bg':        '#02080d',
      '--bg-soft':   '#05131f',
      '--panel':     '#071b2a',
      '--line':      '#23d8ff',
      '--line-soft': '#2b7c91',
      '--text':      '#e8fbff',
      '--muted':     '#aad8e8',
      '--accent':    '#23d8ff',
      '--accent-2':  '#84ecff',
    },
  },
  sunset: {
    label: 'Sunset',
    vars: {
      '--bg':        '#110603',
      '--bg-soft':   '#1b0905',
      '--panel':     '#281008',
      '--line':      '#ff8f32',
      '--line-soft': '#925425',
      '--text':      '#fff0e0',
      '--muted':     '#e0ba9a',
      '--accent':    '#ff8f32',
      '--accent-2':  '#ffd09a',
    },
  },
  magenta: {
    label: 'Magenta',
    vars: {
      '--bg':        '#0f0411',
      '--bg-soft':   '#18051d',
      '--panel':     '#22082a',
      '--line':      '#ff4ac9',
      '--line-soft': '#943e7d',
      '--text':      '#ffe8f7',
      '--muted':     '#e8b0d8',
      '--accent':    '#ff4ac9',
      '--accent-2':  '#ffafe8',
    },
  },
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [themeName, setThemeName] = useState(
    () => localStorage.getItem('af-theme') || 'matrix'
  );

  const themeStyle = useMemo(
    () => themes[themeName]?.vars ?? themes.matrix.vars,
    [themeName]
  );

  function setTheme(name) {
    setThemeName(name);
    localStorage.setItem('af-theme', name);
  }

  return (
    <ThemeContext.Provider value={{ themeName, setTheme, themeStyle, themes }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
